export default __webpack_public_path__ + "static/media/861.da7efb9f.png";